<template>
  <div id="app" class="root">
    <!-- <img src="./assets/logo.png"> -->
    <router-view :key="$route.fullPath" v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const env = ref(import.meta.env.VITE_PROD);

onMounted(() => {
  applyBg();
});



const applyBg = () => {
  // if (env.value === "false") {
  //   document.getElementById("app").style.backgroundColor =
  //     "rgba(255, 255, 153, 0.5)";
  // }
};
if (env.value === "false") {
  console.warn = () => {};
}
</script>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Lato:300,400,700");
@import "../src/assets/main.css";
@import "../src/assets/cards.css";
@import "../src/assets/tables.css";
@import "../src/assets/helpers.css";
#app {
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.root {
  -moz-transition:
    width 0.5s,
    height 0.5s,
    background-color 0s,
    -moz-transform 0.5s;
  -webkit-transition:
    width 0.5s,
    height 0.5s,
    background-color 0s,
    -webkit-transform 0.5s;
  -o-transition:
    width 0.5s,
    height 0.5s,
    background-color 0s,
    -o-transform 0.5s;
  transition:
    width 0.5s,
    height 0.5s,
    background-color 0s,
    transform 0.5s;
  @media (min-width: 360px) {
    width: 100vw;
    height: 100vh;
    /* overflow: hidden; */
    overflow-x: hidden;
  }
  @media (min-width: 768px) {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
  }
}
</style>
